/* Website translation powered by Google Translate's free website widget, the same as the marketing site.
   The widget loads hidden; our own menu drives it and the choice is stored in a cookie Google reads on load. */
export const LANGUAGES = [
  { code: "en", label: "English", native: "English" },
  { code: "sw", label: "Swahili", native: "Kiswahili" },
  { code: "fr", label: "French", native: "Français" },
  { code: "ar", label: "Arabic", native: "العربية", dir: "rtl" },
  { code: "ha", label: "Hausa", native: "Hausa" },
];
const KEY = "twachanga_lang";
const INCLUDED = LANGUAGES.map((l) => l.code).join(",");

export function currentLang() {
  try { return localStorage.getItem(KEY) || "en"; } catch { return "en"; }
}
function setCookie(value) {
  const host = window.location.hostname;
  const exp = value ? "" : "; expires=Thu, 01 Jan 1970 00:00:00 GMT";
  const v = value || "";
  document.cookie = `googtrans=${v}; path=/${exp}`;
  document.cookie = `googtrans=${v}; path=/; domain=${host}${exp}`;
}
let loading = null;
export function loadGoogleTranslate() {
  if (loading) return loading;
  loading = new Promise((resolve) => {
    let host = document.getElementById("google_translate_element");
    if (!host) { host = document.createElement("div"); host.id = "google_translate_element"; host.style.display = "none"; document.body.appendChild(host); }
    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement({ pageLanguage: "en", includedLanguages: INCLUDED, autoDisplay: false }, "google_translate_element");
      resolve();
    };
    const s = document.createElement("script");
    s.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    s.async = true;
    s.onerror = () => resolve();
    document.head.appendChild(s);
  });
  return loading;
}
function applyDir(code) {
  const l = LANGUAGES.find((x) => x.code === code);
  document.documentElement.dir = (l && l.dir) || "ltr";
  document.documentElement.lang = code;
}
export async function setLanguage(code) {
  try { localStorage.setItem(KEY, code); } catch { /* ignore */ }
  applyDir(code);
  if (code === "en") { setCookie(null); window.location.reload(); return; }
  setCookie(`/en/${code}`);
  await loadGoogleTranslate();
  const pick = () => {
    const combo = document.querySelector("select.goog-te-combo");
    if (!combo) return false;
    combo.value = code;
    combo.dispatchEvent(new Event("change"));
    return true;
  };
  if (!pick()) { let n = 0; const t = setInterval(() => { if (pick() || ++n > 40) clearInterval(t); }, 150); }
}
export function restoreLanguage() {
  const code = currentLang();
  applyDir(code);
  if (code !== "en") { setCookie(`/en/${code}`); void loadGoogleTranslate(); }
}
/* React re-renders break when Google Translate wraps text nodes in <font>; this is the standard safety patch. */
export function patchDomForTranslate() {
  if (Node.prototype.__tp) return;
  Node.prototype.__tp = true;
  const rc = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) { if (child.parentNode !== this) return child; return rc.call(this, child); };
  const ib = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, ref) { if (ref && ref.parentNode !== this) return newNode; return ib.call(this, newNode, ref); };
}
